import { render, staticRenderFns } from "./goa-taxi.vue?vue&type=template&id=14ce910c&scoped=true"
import script from "./goa-taxi.vue?vue&type=script&lang=js"
export * from "./goa-taxi.vue?vue&type=script&lang=js"
import style0 from "./goa-taxi.vue?vue&type=style&index=0&id=14ce910c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ce910c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TaxiCard: require('/workspace/components/TaxiCard.vue').default,FaqCard: require('/workspace/components/FaqCard.vue').default})
